var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconPagaTuPrestamo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_150)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_150",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 76,
    height: 76
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 10H11V86H87V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9838 57.3917H65.6206V41.7598C65.6206 39.522 67.4397 37.7007 69.676 37.7007H69.9274C72.1637 37.7007 73.9838 39.522 73.9838 41.7598V57.3917ZM61.1872 78.421C61.1872 80.992 59.0977 83.0829 56.5285 83.0829H56.1544C53.9603 83.0829 52.1282 81.5524 51.6355 79.5068V37.599H61.1872V78.421ZM20.9802 82.9626C18.2331 82.9626 16 80.7539 16 78.0391V13H49V34.6633H48.9603V78.4023C48.9603 78.6197 48.9817 78.831 49 79.0433V82.9626H20.9802ZM69.9274 34.682H69.676C69.6096 34.682 69.5453 34.69 69.4799 34.692L64.1023 34.684V34.682H63.0263H62.8001H51.6355V10H13.0004V78.0578C13.0004 82.4369 16.561 86 20.9372 86H49.4072H51.6355H56.1544H56.5285C60.7045 86 64.1023 82.5999 64.1023 78.421V60.4104H77.0004V41.7598C77.0004 37.8566 73.8279 34.682 69.9274 34.682Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.891 81C20.1898 81 18 78.8835 18 76.2714V15H47V76.2714C47 78.8835 44.8102 81 42.109 81H22.891Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.621 63.3363H38.074V60.3363H25.621V63.3363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.621 72.5253H38.074V69.5253H25.621V72.5253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 42.4172C39.0093 39.6536 37.8085 37.7364 33.2641 36.4566C30.793 35.7387 30.2058 35.3503 30.2058 34.3873C30.2058 33.6841 30.6186 32.9368 31.8813 32.9368C33.5484 32.9368 33.8308 33.9891 33.979 34.6884H38.5778C38.392 32.1542 36.8976 30.1948 33.66 29.675V28H30.1861V29.6888C27.2722 30.2311 25.3593 32.2121 25.3593 35.0306C25.3593 37.653 26.5489 39.5428 31.34 40.8962C33.4949 41.5052 34.0691 42.0053 34.0691 43.0655C34.0691 43.8736 33.6141 44.615 32.1374 44.615C30.7949 44.615 29.9431 43.8775 29.6813 42.6742H25C25.1801 45.3309 26.9119 47.4031 30.323 47.918V50H33.8129V47.915C36.9417 47.4433 38.984 45.6457 39 42.4172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8705 56.1542H66.1805V41.9632C66.1805 40.1162 67.6775 38.6182 69.5255 38.6182C71.3725 38.6182 72.8705 40.1162 72.8705 41.9632V56.1542Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4587 34.2065L83.1146 31.7945L78.4669 34.5243L79.811 36.9363L84.4587 34.2065Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5636 26.37L76.423 24.6694L73.1462 29.0172L75.2869 30.7178L78.5636 26.37Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7023 40.9962L81.3911 41.6938L81.7346 44.4503L87.0459 43.7526L86.7023 40.9962Z",
    fill: "#FF7900"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconPagaTuPrestamo);
export default __webpack_public_path__ + "static/media/menuIcon-PagaTuPrestamo.1d42887cd7db020328fa3341f10bb5ed.svg";
export { ForwardRef as ReactComponent };